import React from 'react'
import { COLORS } from './colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ModalHeading = ({text, closeModal}) => {
  return (
    <div style={{
      width: '100%',
      paddingLeft: 25,
      paddingTop: 25
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        borderBottom: '1px solid '+COLORS.grey,
        fontSize: 18,
        fontWeight: 'bold'
      }}>

        { text }

        <FontAwesomeIcon icon="times" className="link"
          onClick={closeModal}
          style={{
            width: 30,
            color: COLORS.grey,
            position: 'relative',
            bottom: 16
          }}/>
      </div>
    </div>
  )
}

export default ModalHeading;



// WEBPACK FOOTER //
// ./src/components/ModalHeading.js